import { render } from "./defence.vue?vue&type=template&id=64214ea2"
const script = {}

import exportComponent from "/home/runner/work/sec.daragroups.com/sec.daragroups.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__